import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { Profiles } from '../utils/enums/profiles';
import { exemptAdminAppRoutes, exemptAnalystAppRoutes, exemptClientAppRoutes, exemptProviderAppRoutes } from "../utils/constants/profiles-app.exempt.routes";

export const profilesGuardActivate : CanActivateFn = (route, state) =>{
  const router = inject(Router)

  if(!localStorage.getItem('user')) {
    return false;
  }
  const user = JSON.parse(localStorage.getItem('user')!);
  const path = route.routeConfig?.path
  switch(user.profile){
    case Profiles.ADMIN :
      if(path){
        if(exemptAdminAppRoutes.includes(path!)){
          router.navigate(['404'])
          return false
        }
      }
      return true
    case Profiles.ANALIST :
      if(path){
        if(exemptAnalystAppRoutes.includes(path!)){
          router.navigate(['404'])
          return false
        }
      }
      return true
    case Profiles.CUSTOMER :
      if(path){
        const pathTerm = path.split('/').splice(0)[0];
        if(exemptClientAppRoutes.includes(pathTerm!)){
          router.navigate(['404'])
          return false
        }
      }
      return true
    case Profiles.PROVIDER :
      if(path){
        if(exemptProviderAppRoutes.includes(path!)){
          router.navigate(['404'])
          return false
        }
      }
      return true
    default:
      return true;
  }
}
